import { useQuery } from "../AppLayout";
import { Link } from "react-router-dom";

export const workspaceSettingNavItems = (workspaceId) => [
  {
    name: "General",
    href: `/workspaces/${workspaceId}/settings?item=General&key=Settings`,
  },
  {
    name: "Teams",
    href: `/workspaces/${workspaceId}/settings?item=Teams&key=Settings`,
  },
  {
    name: "Sale funnels",
    href: `/workspaces/${workspaceId}/settings?item=Sale funnels&key=Settings`,
  },
  {
    name: "Others",
    href: `/workspaces/${workspaceId}/settings?item=Others&key=Settings`,
  },
];
const SettingNav = ({ navItems, position = "justify-end" }) => {
  const params = useQuery();
  const navItem = params.get("item") || navItems[0].name;
  return (
    <header className={`w-full flex ${position}`}>
      <nav className="flex w-full py-2">
        <ul
          role="list"
          className="flex min-w-full flex-none gap-x-6 text-sm font-semibold leading-6"
        >
          {navItems.map((item) => (
            <li key={item.name}>
              <Link
                to={item.href}
                className={item.name == navItem ? "text-blue-600 border-b-2-blue-900" : ""}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default SettingNav;
